<template>
  <svg
    :width="width"
    :height="height"
    viewBox="0 0 12 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      :style="iconStyle"
      d="M6.66667 1.33337H2.00001C1.64638 1.33337 1.30724 1.47385 1.0572 1.7239C0.807147 1.97395 0.666672 2.31309 0.666672 2.66671V13.3334C0.666672 13.687 0.807147 14.0261 1.0572 14.2762C1.30724 14.5262 1.64638 14.6667 2.00001 14.6667H10C10.3536 14.6667 10.6928 14.5262 10.9428 14.2762C11.1929 14.0261 11.3333 13.687 11.3333 13.3334V6.00004M6.66667 1.33337L11.3333 6.00004M6.66667 1.33337V6.00004H11.3333"
      stroke="#7F56D9"
      stroke-width="1.33333"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>

<script>
export default {
  props: {
    height: {
      type: String,
      default: '16',
    },
    width: {
      type: String,
      default: '12',
    },
    color: {
      type: String,
      default: '',
    },
  },
  computed: {
    /**
     * Icon Style
     * @param {void}
     * @returns {string} - Color
     * @description Assigns the specific color to the icon
     */
    iconStyle: function () {
      return {
        fill: ['$' + this.color, `var(--${this.color})`],
      }
    },
  },
}
</script>
